module.exports = __webpack_public_path__ + "static/media/Codequest_dates.ecafd377.jpg";